import appConfig from 'configs/app.config'  
const { apiPrefixServer,apiReportsServer } = appConfig

//funcion para tomar ordenes
export function getPlanningRoutes(data) {
    var datasend={
        paginationData: data
    }
    const url = `${apiPrefixServer}/get-planningroutes`;
    const params={
        method:"POST",
        body:JSON.stringify(datasend),
        headers:{
            "Content-Type":"application/json"
        }
    };

    return fetch(url, params)
        .then(response => {
            return response.json();
        })
        .then(result => {
            return result;
        })
        .catch(err => {
            return err.message;
        });
}

export function getPlanningRoute(id) {
    const url = `${apiPrefixServer}/get-planningroute/${id}`;
    const params = {
        method: "GET",
        headers: {
            "Content-Type": "applicaction/json"
        }
    };
    return fetch(url, params)
        .then(response => {
            return response.json();
        })
        .then(result => {
            return result;
        })
        .catch(err => {
            return err.message;
        });
}

export function getPlanningRouteDetails(id) {
    const url = `${apiPrefixServer}/get-planningroutedetails/${id}`;
    const params = {
        method: "GET",
        headers: {
            "Content-Type": "applicaction/json"
        }
    };
    return fetch(url, params)
        .then(response => {
            return response.json();
        })
        .then(result => {
            return result;
        })
        .catch(err => {
            return err.message;
        });
}
export function createPlanningRoute(data){
    const url=`${apiPrefixServer}/post-planningroute`;
    const params={
        method:"POST",
        body:JSON.stringify(data),
        headers:{
            "Content-Type":"application/json"
        }
    };
    return fetch(url,params)
    .then(response=>{
        return response.json();
    })
    .then(result=>{
        return result;
    })
    .catch(err=>{
        return err.message;
    });
}


export function updatePlanningRoute(data, id){ 
    const url=`${apiPrefixServer}/update-planningroute/${id}`;
    const params={
        method:"PUT",
        headers:{
            "Content-Type": "application/json",
                },
        body: JSON.stringify(data)
    };
    return fetch(url,params)
    .then(response=>{
        return response.json();
    })
    .then(result=>{
        return result;
    })
    .catch(err=>{
        return err.message;
    });
}

export function updateAddDetailtoPlanningRoute(data, id){ 
    const url=`${apiPrefixServer}/update-additemtoplanningroute/${id}`;
    const params={
        method:"PUT",
        headers:{
            "Content-Type": "application/json",
                },
        body: JSON.stringify(data)
    };
    return fetch(url,params)
    .then(response=>{
        return response.json();
    })
    .then(result=>{
        return result;
    })
    .catch(err=>{
        return err.message;
    });
}


export function deletePlanningRoute(id){
    const url=`${apiPrefixServer}/delete-planningroute/${id}`;
    const params ={
        method: "DELETE",
        headers:{
            "Content-Type": "application/json",
        }
    }
    return fetch(url,params)
    .then(response => {
        return response.json();
    })
    .then(result=>{
        return result.message;
    })
    .catch(err=>{
        return err.message;
    })
}
//Cerrar orden y facturar
export function closePlanningRoute(id){
    const url=`${apiPrefixServer}/close-planningroute/${id}`;
    const params ={
        method: "POST",
        headers:{
            "Content-Type": "application/json",
        }
    }
    return fetch(url,params)
    .then(response => {
        return response.json();
    })
    .then(result=>{
        return result.message;
    })
    .catch(err=>{
        return err.message;
    })
}

//Imprimir ticket orden
export function printRoute(id,formato){
    const url=`${apiReportsServer}/planningroute?id=${id}`;
    const params ={
        method: "POST",
        headers:{
            "Content-Type": "application/json",
        }
    }
    return fetch(url,params)
    .then(response => {
        console.log("response", response._bodyText)
        return response;
    })
    .then(result=>{
        return result;
    })
    .catch(err=>{
        return err.message;
    })
}
